import styled from 'styled-components';

const JustifyMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: ${({padding})=>padding || 0};
  >h2 {
    color: #2A2D35;
    margin-right: 20px;
  }
  >a {
    .fa {
      margin-left: 6px;
      font-size: 20px;
    }
    font-size: 22px;
    font-weight: 500;
  }
  @media (max-width: 768px) {
    margin: 20px 0 0px;
  }
`;

export default JustifyMenu;
